import * as React from 'react'

import { Button as ButtonPrimitive } from '@base-ui/react/button'

import { cn } from '@crm/shared/lib/styles/utils'
import {
  type ButtonSize,
  type ButtonVariant,
  buttonVariants,
  type ButtonVariants,
} from '@crm/shared/ui'

type ButtonProps = ButtonPrimitive.Props & ButtonVariants

export const Button = React.forwardRef<React.ElementRef<typeof ButtonPrimitive>, ButtonProps>(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => (
    <ButtonPrimitive
      ref={ref}
      data-slot='button'
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  ),
)

Button.displayName = 'Button'

export type { ButtonProps, ButtonSize, ButtonVariant, ButtonVariants }
